import { OpeningClosingHoursType } from "./opening-closing-hours.request.model";

export class OpeningClosingHoursResponse{
    id:number;
    friEFrom: string;
    friETo: string;
    friMFrom: string;
    friMTo: string;
    monEFrom: string;
    monETo: string;
    monMFrom: string;
    monMTo: string;
    satEFrom: string;
    satETo: string;
    satMFrom: string;
    satMTo: string;
    storeId: number;
    sunEFrom: string;
    sunETo: string;
    sunMFrom: string;
    sunMTo: string;
    thuEFrom: string;
    thuETo: string;
    thuMFrom: string;
    thuMTo: string;
    tueEFrom: string;
    tueETo: string;
    tueMFrom: string;
    tueMTo: string;
    wedEFrom: string;
    wedETo: string;
    wedMFrom: string;
    wedMTo: string;
    type: OpeningClosingHoursType;
    note: string;
    constructor(){
        this.friEFrom = null;
        this.friETo = null;
        this.friMFrom = null;
        this.friMTo = null;
        this.monEFrom = null;
        this.monETo = null;
        this.monMFrom = null;
        this.monMTo = null;
        this.satEFrom = null;
        this.satETo = null;
        this.satMFrom = null;
        this.satMTo = null;
        this.sunEFrom = null;
        this.sunETo = null;
        this.sunMFrom = null;
        this.sunMTo = null;
        this.thuEFrom = null;
        this.thuETo = null;
        this.thuMFrom = null;
        this.thuMTo = null;
        this.tueEFrom = null;
        this.tueETo = null;
        this.tueMFrom = null;
        this.tueMTo = null;
        this.wedEFrom = null;
        this.wedETo = null;
        this.wedMFrom = null;
        this.wedMTo = null;
        this.type = OpeningClosingHoursType.STANDARD;
        this.note = null;
    }
}

export class OpeningClosingHoursResponseCreate extends OpeningClosingHoursResponse{
    constructor(){super();}
} 

export class OpeningClosingHoursResponseGet extends OpeningClosingHoursResponse{
    constructor(){super();}
}

export class OpeningClosingHoursResponseUpdate extends OpeningClosingHoursResponse{
    constructor(){super();}
}

export class OpeningClosingHoursResponseSearch{
    data: OpeningClosingHoursResponse[];
    limit: number;
    page: number;
    total: number;
    
}